import Error from 'next/error'
import MetaSeo from '../../components/atomic/MetaSeo'
import { PAGINEDETAIL } from '../../utils/endpoint'
import { api } from '../../utils'
import IoPiu2Template from '../../components/template/IoPiu2Template'
import React from 'react'

const IoPiu = React.memo(({ page, statusCode }) => {
  if (!page) return <Error statusCode={statusCode} />

  return (
    <>
      <MetaSeo seo={page.seo} />
      <IoPiu2Template />
    </>
  )
})

export const getStaticProps = async () => {
  const pageResponse = await api.get(PAGINEDETAIL, {
    params: {
      chiave: 'iopiu',
    },
  })
  const page = await pageResponse.data

  const toolbarProps = { toolbarPage: page }

  return { props: { page, ...toolbarProps }, revalidate: 60 * 10 }
}

export default IoPiu
